import { useLocation } from "@solidjs/router";
import { onMount } from "solid-js";
import { useWire } from "~/wire";

/**
 * Hook to handle the `?chatwith=` URL parameter for adding an asset to chat scope.
 * This is used when the Chrome extension links to the webapp with an asset ID.
 * The asset is added to the chat scope if it exists in the current project.
 */
export const useChatwithUrlParameter = () => {
  const location = useLocation();
  const wire = useWire();

  onMount(() => {
    const chatwithParam = location.query.chatwith;
    const ids = Array.isArray(chatwithParam) ? chatwithParam : typeof chatwithParam === "string" ? [chatwithParam] : [];
    if (ids.length === 0) return;

    try {
      for (const raw of ids) {
        const decodedAssetId = decodeURIComponent(raw);
        if (!decodedAssetId.trim()) continue;
        wire.chat.scope.addAsset(decodedAssetId);
      }
    } catch (error) {
      console.warn("[useChatwithUrlParameter] Failed to decode chatwith parameter:", error);
    }
  });
};
